export interface Account {
  _id?: string;
  name: string;
  number: string;
  display?: any;
}

export interface Client {
  _id?: string;
  name: string;
  country: string;
  currency: string;
  status: string;
  accounts: Account[] | any;
  logoId: string;
  esg: boolean;
  productDocument: boolean;
  taxDetail: boolean;
}

export interface MainFilter {
  account: Account[];
  client: Client[];
}

export interface StaticDataPayload {
  key: string;
  value: string;
  country: string | null;
  client: string | null;
  year: string | null;
  month: string | null;
}

export interface ResourceRequestPayload {

  type: string | null;
  country: string | null;
  accountId: string | null;
  clientId: string | null;
  subject: string | null;
  message: string | null;
  isServiceRequest: boolean | null;
  requestorId: string | null;
}

export enum ResourceRequestTypes {
  AMEND_MY_CONNECTIONS = 'amendMyConnections',
  BOOK_DEMO = 'bookDemo',
  FEEDBACK = 'provideFeedback',
  REPORT_ISSUE = 'reportIssue',
  REQUEST_INFORMATION = 'requestInformation',
  OTHER = 'other'
}

export interface ResourceRequestOption {
  value: string;
  label: string;
}

export const ResourceRequestOptions: ResourceRequestOption[] = [
  {
    value: 'amendMyConnections',
    label: `Amend the list of users from 'My Connections' page`
  },
  {
    value: 'bookDemo',
    label: 'Book a Demo'
  },
  {
    value: 'provideFeedback',
    label: 'Provide Feedback'
  },
  {
    value: 'reportIssue',
    label: 'Report an issue'
  },
  {
    value: 'requestInformation',
    label: 'Request Information'
  },
  {
    value: 'other',
    label: 'Other'
  }
];
